import { handleActions } from 'redux-actions';
import { push } from "react-router-redux";
import { initialize as initializeForm } from 'redux-form';
import Swal from 'sweetalert2';
import { api } from "api";

const LOADER = 'ASUETO_LOADER';
const DATA = "ASUETO_DATA";
const SUBMIT = "ASUETO_SUBMIT";
const HOLIDAYS = "ASUETO_HOLIDAYS";
const LOADER_HOLIDAYS = "ASUETO_LOADER_HOLIDAYS";

const ENDPOINT = "asueto";

export const constants = {
    SUBMIT,
};

// ------------------------------------
// Pure Actions
// ------------------------------------

export const setLoader = loader => ({
    type: LOADER,
    loader,
});

export const setData = data => ({
    type: DATA,
    data
});

export const setHolidays = holidays => ({
    type: HOLIDAYS,
    holidays
});

export const setLoaderHolidays = loaderHolidays => ({
    type: LOADER_HOLIDAYS,
    loaderHolidays
});

// ------------------------------------
// Actions
// ------------------------------------
export const onSubmit = (data = {}) => (dispatch, getStore) => {
    dispatch(setLoader(true));
    api.post(`${ENDPOINT}`, data).then(() => {
        Swal.fire({
            title: 'Éxito',
            text: 'Se ha guardado correctamente',
            type: 'success',
        })
        dispatch(push("/asuetos"));
    }).catch((error) => {
        const textError = error && error.non_field_errors
        ? error.non_field_errors[0]
        : 'Ha ocurrido un error, inténtelo nuevamente.'
        ;
        Swal.fire({
            title: 'Error',
            text: textError,
            type: 'error',
        })
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const listar = (page=1, params={}) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`${ENDPOINT}`, { page, ...params }).then(response => {
        dispatch(setData(response));
    }).catch(() => {
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const obtenerAsueto = (id=null) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`${ENDPOINT}/${id}`).then(response => {
        dispatch(initializeForm('CrearEditarForm', response));
    })
        .catch(() => {
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const actualizarAsueto = (data={}, id=null) => (dispatch) => {
    dispatch(setLoader(true));
    api.put(`${ENDPOINT}/${id}`, data).then(() => {
        Swal.fire({
            title: 'Éxito',
            text: 'Se ha actualizado correctamente',
            type: 'success',
        })
        dispatch(push("/asuetos"));
    }).catch((error) => {
        const textError = error && error.non_field_errors
        ? error.non_field_errors[0]
        : 'Ha ocurrido un error, inténtelo nuevamente.'
        ;
        Swal.fire({
            title: 'Error',
            text: textError,
            type: 'error',
        })
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const eliminar = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.eliminar(`${ENDPOINT}/${id}`).then(() => {
        Swal.fire({
            title: 'Éxito',
            text: 'Se ha eliminado correctamente',
            type: 'success',
        })
    })
        .catch(() => {
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const getHolidays = (params = {}) => (dispatch) => {
    dispatch(setLoaderHolidays(true));
    api.get("asueto/get_events_projects", params).then(response => {
        dispatch(setHolidays(response));
    }).catch(() => {
    }).finally(() => {
        dispatch(setLoaderHolidays(false));
    });
};

export const actions = {
    onSubmit,
    eliminar,
    obtenerAsueto,
    actualizarAsueto,
    listar,
    getHolidays,
};

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [DATA]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [HOLIDAYS]: (state, { holidays }) => {
        return {
            ...state,
            holidays
        }
    },
    [LOADER_HOLIDAYS]: (state, { loaderHolidays }) => {
        return {
            ...state,
            loaderHolidays
        }
    },
};

export const initialState = {
    loader: false,
    data: [],
    loaderHolidays: false,
    holidays: [],
};

export default handleActions(reducers, initialState);
